module.exports = __webpack_public_path__ + "img/borrower_benefit_future.f783924b.jpg";